import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

if (window.location.href.includes("nenaandpasadena")) {
    var linkElement = document.createElement('link');
    var head = document.getElementsByTagName('head')[0];
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('type', 'text/css');
    linkElement.setAttribute('href', 'https://nosto-campaign-assets.s3.amazonaws.com/neverland-ksc-nxp/nxp.css');
    head.appendChild(linkElement);
}

if (window.location.href.includes("kisschacey")) {
    var linkElement = document.createElement('link');
    var head = document.getElementsByTagName('head')[0];
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('type', 'text/css');
    linkElement.setAttribute('href', 'https://nosto-campaign-assets.s3.amazonaws.com/neverland-ksc-nxp/ksc.css');
    head.appendChild(linkElement);
}

function nostoInitSearch(){
    init({
        ...window.nostoTemplatesConfig,
        serpComponent: Serp,
        // historyComponent: History,
        autocompleteComponent: Autocomplete,
        categoryComponent: Category,
        inputCssSelector: ".modal__body .search__input, .search__input",
        contentCssSelector: ".pagination__container > div",
        formCssSelector: '.modal__body form.search__form',
        serpUrlMapping: {
            query: "q",
            "products.filter": "filter",
            "products.page": "page",
            "products.sort": "sort"
        },
        serpPath: '/search',
        serpPathRedirect: window.location.href.indexOf("/search") > -1 ? false : true,
        serpQuery: {
            products: {
                facets: ["*"],
                size: defaultConfig.serpSize,
                from: 0
            }
        },
        autocompleteQuery: {
            products: {
                fields: [
                    "productId",
                    "url",
                    "name",
                    "imageUrl",
                    "thumbUrl",
                    "brand",
                    "availability",
                    "price",
                    "priceText",
                    "listPrice",
                    "ratingValue",
                    "reviewCount"
                ],
                size: defaultConfig.autocompleteProductsSize
            },
            keywords: {
                fields: ["keyword", "_highlight.keyword"],
                size: defaultConfig.autocompleteKeywordsSize,
                facets: ["*"]
            },
        },
        compressUrlParameters: true,
        fallback: false,
        queryModifications(query) {
            return {
                ...query,
                products: {
                    ...(query.products ?? {}),
                    filter: [
                        ...(query.products.filter ?? []),
                        {
                            field: "skus.availability",
                            value: ["InStock"]
                        }
                    ]
                }
            }
        },
        // Uncomment for Category Merchandising
        
        // categoryCssSelector: 'main#MainContent',
        categoryCssSelector: '.pagination__container',
           categoryQuery() {
            return {
                name: 'category',
                products: {
                    categoryId: this.categoryId(),
                    categoryPath: this.categoryPath(),
                    size: defaultConfig.serpSize,
                    from: 0
                }
            }
        },
    })
}



const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

// if the url contains parameter "q" then init search
if(urlParams.get("q") != null){
    nostoInitSearch()
} else if(window.location.href.indexOf("/collections/") > -1){
    nostoInitSearch()
} else {
    // otherwise start search when a user clicks on the magnifying glass icon
    document.querySelectorAll(".modal__trigger.search-modal__trigger").forEach(el=>{
        el.addEventListener("click", function(){
            nostoInitSearch();
            setTimeout(() => {
                jQuery(".nosto-autocomplete-wrapper .search__input").focus();
            }, 300);
        })
    })
}